<template>
    <div class='text-13 h-6 px-3 border bg-opacity-10 flex items-center w-fit'
        :class='[ getTemperature[1] ]' v-if='value !== null'
    >
        <span>{{ getTemperature[0] }}</span>
    </div>
</template>

<script>
    export default {
        props: {
            value: { type: [String, Number], default: null }
        },  

        computed: {
            getTemperature() {
                switch (this.valueToString) {
                    case 'lost': return ['Lost', 'bg-grey-800 border-grey-800 text-grey-800']; break;
                    case 'cold': return ['Cold', 'bg-blue-600 border-blue-600 text-blue-600']; break;
                    case 'warm': return ['Warm', 'bg-red-600 border-red-600 text-red-600']; break;
                    case 'hot': return ['Hot', 'bg-red-700 border-red-700 text-red-700']; break;
                    default: return ['Lost', 'bg-grey-800 border-grey-800 text-grey-800']
                }
            },

            valueToString() {
                if (typeof this.value == 'number') {
                    switch (true) {
                        case this.value == 20: return 'cold'; break;
                        case this.value == 50: return 'warm'; break;
                        case this.value == 80: return 'hot'; break;
                    }
                }

                return this.value.toString().toLowerCase();
            }
        }
    }
</script>